(function () {
  function centerFeaturedDiscount(el) {
    var featured = el.querySelector('.bdl-volume-discounts__card--featured');
    if (!featured) return;

    if (el.scrollWidth <= el.clientWidth + 1) {
      el.scrollLeft = 0;
      return;
    }

    var target = featured.offsetLeft - (el.clientWidth - featured.offsetWidth) / 2;
    el.scrollLeft = Math.max(0, target);
  }

  function initDragScroll(el) {
    if (!el || el.dataset.bdlDragScroll === 'true') return;

    el.dataset.bdlDragScroll = 'true';

    var isDragging = false;
    var mightDrag = false;
    var startX = 0;
    var scrollStart = 0;
    var moved = false;
    var activePointerId = null;

    el.addEventListener('pointerdown', function (event) {
      if (event.pointerType !== 'mouse' || event.button !== 0) return;

      mightDrag = true;
      isDragging = false;
      moved = false;
      activePointerId = event.pointerId;
      startX = event.clientX;
      scrollStart = el.scrollLeft;
    });

    el.addEventListener('pointermove', function (event) {
      if (!mightDrag || event.pointerId !== activePointerId) return;

      var delta = event.clientX - startX;

      if (!isDragging && Math.abs(delta) > 4) {
        isDragging = true;
        moved = true;
        el.classList.add('is-dragging');

        if (el.setPointerCapture) {
          el.setPointerCapture(event.pointerId);
        }
      }

      if (isDragging) {
        event.preventDefault();
        el.scrollLeft = scrollStart - delta;
      }
    });

    function endDrag(event) {
      if (!mightDrag || (event && event.pointerId !== activePointerId)) return;

      mightDrag = false;
      activePointerId = null;

      if (isDragging) {
        isDragging = false;
        el.classList.remove('is-dragging');

        if (event && el.releasePointerCapture && el.hasPointerCapture(event.pointerId)) {
          el.releasePointerCapture(event.pointerId);
        }
      }
    }

    el.addEventListener('pointerup', endDrag);
    el.addEventListener('pointercancel', endDrag);
    el.addEventListener('lostpointercapture', function () {
      mightDrag = false;
      isDragging = false;
      activePointerId = null;
      el.classList.remove('is-dragging');
    });

    el.addEventListener('click', function (event) {
      if (moved) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }

      moved = false;
    }, true);

    if (el.querySelector('.bdl-volume-discounts__card--featured')) {
      var resizeTimer;
      var centerFeatured = function () {
        centerFeaturedDiscount(el);
      };

      centerFeatured();
      window.requestAnimationFrame(centerFeatured);
      window.setTimeout(centerFeatured, 120);

      window.addEventListener('resize', function () {
        window.clearTimeout(resizeTimer);
        resizeTimer = window.setTimeout(centerFeatured, 150);
      });
    }
  }

  function initAll() {
    document.querySelectorAll('[data-bdl-drag-scroll]').forEach(initDragScroll);
  }

  window.bdlInitDragScroll = initDragScroll;

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('bdl:init-drag-scroll', function (event) {
    if (event.detail && event.detail.element) {
      initDragScroll(event.detail.element);
    }
  });
})();
